/* src/app/private/components/contact/delete-contact/delete-contact.component.scss */
/*# sourceMappingURL=delete-contact.component.css.map */
